import { createFileRoute, redirect } from '@tanstack/react-router'

import { OrganizationAdmin } from '~/components/authorize/OrganizationAdmin'
import { isApiKeysEnabled } from '~/constants/featureFlag'
import { ApiKeyRoleDetail } from '~/pages/ApiKeys/roleDetail'

const ApiKeyRoleDetailPage: React.FC = () => {
  const { roleId } = Route.useParams()
  return (
    <OrganizationAdmin thorwError>
      <ApiKeyRoleDetail roleId={roleId} />
    </OrganizationAdmin>
  )
}

export const Route = createFileRoute('/_authenticated/api_keys/roles/$roleId')({
  beforeLoad: () => {
    if (!isApiKeysEnabled) {
      // redirect() は throw して使うのが TanStack Router の作法
      throw redirect({ to: '/' })
    }
  },
  component: ApiKeyRoleDetailPage,
})
